import ManageTagContainer from './ManageTagContainer';

export default ManageTagContainer;
